import {
    setRegions,
    setSelectedCountry,
    setGroupTypeForSelectedCountry,
    setGroupType
} from '../actions/countrySelectActions';
import { generate } from '../utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../utils/renderUtils';
import {
    getGroupTypeForSelectedCountry,
    getGroupTypeByCountry
 } from '../utils/validationUtils';
import { triggerCountrySelect } from '../utils/eventUtils';

/**
 * Attach component events to DOM
 * @param {Object} store    The redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    const state = store.getState();

    function getRegionsForSelectedCountry() {
        const siteIndex = $('.js-country-select').data('index');
        const countryIndex = $('.js-country-select option:selected').data('index');

        return state.core.siteConfig.sites[siteIndex].countries[countryIndex].regions;
    }

    function getRegionsForSelectedNorthAmericanCountry() {
        const countryIndex = $('.js-north-american-country-select option:selected').data('index');

        return state.help.northAmericaCountries.countries[countryIndex].regions;
    }

    $(document).on(this.scopedEvent('change'), '.js-country-select', () => {
        const selectedCountryCode = $('.js-country-select').val();
        const groupType = getGroupTypeByCountry(store.getState(), selectedCountryCode);

        store.dispatch(setGroupType(groupType));
        store.dispatch(setRegions(getRegionsForSelectedCountry()));
        store.dispatch(setSelectedCountry(selectedCountryCode));
        store.dispatch(setGroupTypeForSelectedCountry(getGroupTypeForSelectedCountry(groupType)));
    });

    $(document).on(this.scopedEvent('change'), '.js-north-american-country-select', () => {
        const selectedCountryCode = $('.js-north-american-country-select').val();
        const groupType = getGroupTypeByCountry(store.getState(), selectedCountryCode);

        store.dispatch(setGroupType(groupType));
        store.dispatch(setRegions(getRegionsForSelectedNorthAmericanCountry()));
        store.dispatch(setSelectedCountry(selectedCountryCode));
        store.dispatch(setGroupTypeForSelectedCountry(getGroupTypeForSelectedCountry(groupType)));
    });
}

function afterConstruction(store) {
    triggerCountrySelect();
}

export function init(store, overrides = {}) {
    const config = {
        name: 'countrySelectComponent',
        attachEvents: attachEvents,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides);
}
